	$(function(){
		
// THEME
// ---------------------------------------	
		
		// Detech IE7
		IE7 = (navigator.appVersion.indexOf("MSIE 7.")==-1) ? false : true;
		IE9 = (navigator.appVersion.indexOf("MSIE 9.")==-1) ? false : true;
		
		
		// Philip McLaughlin - Format Image

			$.fn.formatImages = function(height,width,callback) {
				
						if(IE9 == true) {
							var osrc = $(this).attr('src');
							var msrc = osrc.split('?');
							$(this).attr('src',msrc[0]);
						};
						
			    $(this).imagesLoaded( function(){
							var tch = height;
							var tih = $(this).height();
							var ho = ( tch - tih ) / 2;
							var tcw = width;
							var tiw = $(this).width();
					
							if ( tih < tch) {
								$(this).css('margin-top', ho).fadeIn();
							}
							else if ( tih > tch && tiw <= tcw ) {
								$(this).css('height', tch ).fadeIn();
							}
							else {
								$(this).fadeIn();
							};
							
							$(this).addClass('processed');
							
					});
						
			};
		
			// General
		
			
			// Input Field Formatting
			
				// Search 
					$('#q-span').click(function(){
						$(this).fadeOut(150);
						$('#search-field').focus();
					});
				
					$('#search-field').blur(function(){
						if ($(this).val() == '') {
							$('#q-span').fadeIn(150);
						}
					});
				
				// Subscribe
					$('#fq-span').click(function(){
						$(this).fadeOut(150);
						$('#newsletter-field').focus();
					});

					$('#newsletter-field').blur(function(){
						if ($(this).val() == '') {
							$('#fq-span').fadeIn(150);
						}
					});
			
		
			// Drop Down Navigation
				
				
				// Mega Drop Down
				$("li.drop-hover").mouseenter(function(){
				    	
						var elem = $(this);
						elem.find('.sub-menu').show();
						elem.find('a').css('background-color','#000000');
						if( elem.hasClass('current') ){
  							$(elem).find("a.drop-hover").css('color','#ffffff');
						};
						
				}).mouseleave(function(){
					
					var elem = $(this);
					elem.find('.sub-menu').hide();
					elem.find('a').css('background-color','');
					if( elem.hasClass('current') ){
						$(elem).find("a.drop-hover").css('color','#006aff');
					};
												
				});
		
				// Link List Drop Down
				$("li.smart-drop").mouseenter(function(){
					
					var elem = $(this);
					
					elem.find('.smart-sub-menu').show();
					elem.find('a').css('background-color','#000000');
					
					if( elem.hasClass('current') ){
						elem.find('a.drop-hover').css('color','#ffffff');
					};
					
				}).mouseleave(function(){
					
					var elem = $(this);
					
					elem.find('.smart-sub-menu').hide();
					elem.find('a').css('background-color','');
					
					if( elem.hasClass('current') ){
						elem.find('a.drop-hover').css('color','#006aff');
					};

				});
		
			// Format logo text
			
				// 1. Center header text
					
					if($('#logo h1 a').text().length > 9){
						$('#logo h1 a').css('font-size','27px');
					}
					
					
						$('#logo').css('height',$('#header').height());
						var mt = (($('#header').height() - $('#logo h1').height()) / 2) -6;
						$('#logo h1').css('margin-top', mt).animate({opacity:1});
							
		
				// 2. Center footer text
				
					if($('#footer-logo h2 a').text().length > 9){
						$('#footer-logo h2 a').css('font-size','27px');
					}
				
					
						$('#footer-logo').css('height',$('#footer-meta').height());
						var mt = (($('#footer-meta').height() - $('#footer-logo h2').height()) / 2) - 6;
						$('#footer-logo h2').css('margin-top', mt).animate({opacity:1});
					
					
			
				// 3. Fade twitter-glyph in
				
					$('#twitter-glyph-inner img').imagesLoaded(function(){
						$('#twitter-glyph').fadeTo('fast',1);
					});

				


// INDEX 	
// ---------------------------------------			
		
		// Slideshow
		
			// Setup
				var sw = 980 													// Slide width
				var cp = 0														// Current position
				var slides = $('.slide');										// Gather all slides
				var ns = slides.length	- 1										// Number of slides
				var tsc = 0
				var autoSlideID;
			
				$('#theSlider').css('width', (ns + 1) * sw);					// Set the width of 'theSlider'
				
				
				$('.slide img').each(function(){
					$(this).imagesLoaded(function(){

						$('.slide').show();

						
							if (ns > 0 && tsc == ns) {

								
								function startAutoSlide() {
									autoSlideID = setInterval(autoSlide,7000);
								};
								startAutoSlide();

							};
							

						tsc++;

					});
				});
				
				
				if ( ns > 0 ) {
					$('#slide-next').fadeIn();
				};
				
			// Basic functions
		
				function nextSlide() {
					
					if ( cp != ns ) {
						
						$('#slide-controls li#' + cp).removeClass('focused');
						cp++
						$('#slide-controls li#' + cp).addClass('focused');

						$('#theSlider').animate({
							marginLeft: sw * (-cp)
						});
						
					}

					if ( cp == ns ) {
						$('#slide-next').fadeOut();
					}

					if ( cp > 0 ) {
						$('#slide-prev').fadeIn();
					}
						
					
				
				};
		
				function previousSlide() {
					
					if ( cp != 0 ) {
					
						$('#slide-controls li#' + cp).removeClass('focused');
						cp--
						$('#slide-controls li#' + cp).addClass('focused');

						$('#theSlider').animate({
							marginLeft: sw * (-cp)
						});
						
					};

					if ( cp < ns ) {
						$('#slide-next').fadeIn();	
					}

					if ( cp == 0 ) {
						$('#slide-prev').fadeOut();
					}
						
					
				
				};
		
				function resetSlides() {
					$('#theSlider').animate({
						marginLeft: 0
					});
					
					$('#slide-controls li').removeClass('focused');
					$('#slide-controls li#0').addClass('focused');
					
					$('#slide-next').fadeIn();
					$('#slide-prev').fadeOut();
					
					cp = 0
					
				};
				
				function autoSlide() {
					
					if ( ns > 0 ) {
						
						if ( cp < ns ) {
							nextSlide();
							if ( cp == ns ) {
								$('#slide-next').fadeOut();
							}
							return false;
						}
						
						if ( cp == ns ) {
							resetSlides();
							return false;
						}
						
					}
					
				};
				
				
				
				
			
			// Build slide controls
				if (ns > 0) {
					$(slides).each(function(i){
						$('#slide-controls').append('<li class="" id='+i+'>•</li>');
						if ( i == 0 ) {
							$('li#0').addClass('focused');
						};
					});	
				};
			
		
			// Move to particular slide
				$('#slide-controls li').each(function(i) {
					$(this).click(function(){
						
						
							clearInterval(autoSlideID);
						
						
						cp = this.id;
						$('#theSlider').animate({
							marginLeft: sw * (-cp)
						});
						$('#slide-controls li').removeClass('focused');
						$(this).addClass('focused');
						
						if ( cp == ns ) {
							$('#slide-next').fadeOut();
						}

						if ( cp > 0 ) {
							$('#slide-prev').fadeIn();
						}
						
						if ( cp < ns ) {
							$('#slide-next').fadeIn();	
						}

						if ( cp == 0 ) {
							$('#slide-prev').fadeOut();
						}
						
					});
				});	
			
			// Move to next slide
				$('#slide-next').click(function(){		
					
					
						clearInterval(autoSlideID);
							
									
					nextSlide();
				});
		
			// Move to previous slide
				$('#slide-prev').click(function(){
					
					
						clearInterval(autoSlideID);
					
					
					previousSlide();
				});

		
		// Blog previewer
	
				// Assign blog articles IDs and Classes
					$('.preview-article').each(function(i){
						i++
						$(this).attr('id','news-item-'+i);
						if ( i == 1 ) {
							$(this).addClass('active-article');
						}
					});
				
				// Display first blog post 
					$('#news-item-1').show();
			
				
				// Count and Add Controls
					
					var listCount = $('#latest-news-controls li').size();
					
					
				
				// Controls
					$('#latest-news-controls li').each(function(i){
						
						i++
						
						// Assign control IDs and Classes
						
							if ( $(this).attr('class') == 'more-articles' ) {
								$(this).attr('id',i+'-show');
							}
							else
							{
								$(this).attr('id',i+'-show').html(i);
							}
			
							if ( i == 1 ) {
								$(this).addClass('active-control');
							}
				
							var lid = this.id;
							var lid_num = lid.substr(0, 1);
						
						
						// Event
							$(this).click(function(){
				
								$('.active-article').fadeOut(150,function(){
									$('#news-item-' + lid_num).fadeIn(150).addClass('active-article');
								});
				
								$('#latest-news-container .preview-article').removeClass('active-article');
								
								$('#more-articles span').removeClass('active');
								$('#latest-news-controls li').not($(this)).removeClass('active-control');
								$(this).addClass('active-control');
								
							});
					});
					
		// Display "More Articles"
		
			$('#more-articles').click(function(){
				$('#latest-news-controls li').removeClass('active-control');
				$('#more-articles span').addClass('active');
				
				$('.active-article').fadeOut(150,function(){
					$('.more-articles-container').fadeIn(150).addClass('active-article');
				});
				
			});
					
		
		// Set front-page product heights
		
			var ph = 0
		
			$('.product-meta').each(function(){
				if ($(this).height() > ph ) {
					ph = $(this).height();
				}
			});
		
			$('.product-meta').css('height', ph);
		
		
// COLLECTIONS 
// ---------------------------------------
		

		// Set catalogue product heights
		
			var cph = 0
		
			$('.collection-meta').each(function(){
				if ($(this).height() > cph ) {
					cph = $(this).height();
				}
			});
		
			$('.collection-meta').css('height', cph);



// ---------------------------------------
	});
	
	
	
	
	
	
	
	
	
	
	
	